import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OffersService {

  constructor() { }

  static getOffersModules(): Array<string> {
    return [
      'HotelsByIdsModule',
      'HotelsByCityAndCategoriesModule',
      'ActivitiesModule',
      'PackagesModule',
      'TopSearchesPackagesModule',
      'TopSearchesBundlesModule',
      'TopSearchesGetawayModule',
      'TopSearchesFlightsModule',
      'TopSearchesHotelsModule',
      'TopSearchesActivitiesModule',
      'HotelsModule',
      'FlightAirlineBestOffersModule',
      'CheapestFlightsByTravelWindowModule',
      'CarDealsModule',
      'AssistanceModule',
      'RentalsModule',
      'CarRentalAgencyBestOffersModule',
      'MultidestinationFlightsModule',
      'TransfersModule',
      'GetawayModule',
      'BundlesModule',
      'FlightsDealsModule',
      'PackagesUnbeatableModule',
      'MultiproductOffersModule',
      'ActivitiesModalitiesModule',
      'HotelsByCityModule',
      'UnbeatablesPackagesV2Module',
      'CarBestOfferForCountryModule',
      'PackagesAllInclusiveModule',
      'HotelsByPartnerModule',
      'LandingPackageV2Module',
      'KillersModule',
      'CircuitsModule',
      'RecommendedOffersModule',
      'UnbeatableHotelsModule',
      'HotelsWowModule',
      'TopSearchesHotelsWowModule',
      'SortedOffersModule',
      'CheapestCountriesModule'
    ];

  }

  static useOfferModule(moduleId: string): boolean {
      return this.getOffersModules().includes(moduleId);
  }
}
